<template>
  <div class="outer-container">
    <div class="container">
      <div class="inner-container">
        <div class="">
          <iframe
            width="849"
            height="478"
            class="video"
            src="https://www.youtube.com/embed/HX0OjE81zIc"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
          <p class="credits">Video Credit - Intelligent Machines Ltd.</p>
        </div>
        <div class="flex-right">
          <div class="upper">
            <img src="../../assets/DataScience/as.svg" alt="" />
            <h3>
              Data is everywhere around us. Shortly, we will need the capability
              to make sense of all the data around us, in any job, whether in
              businesses, medicine, hospitality, and even tourism. The skill to
              drive decisions with data is versatile! This boot camp will help
              you take the first major leap to achieve the skills to collect,
              visualize, analyze and drive decisions with data
            </h3>
          </div>
          <div class="lower">
            <h2>
              Khan Muhammad Saqiful Alam
            </h2>
            <h5>
              Program Manager,Trust and Safety, <br />

              South Asia Region, TikTok
            </h5>

            <img
              src="../../assets/DataScience/Group 20.svg"
              alt=""
              style="text-align:right"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.credits {
  font: 400 0.75rem/1rem 'Manrope';
  color: #626367;
}
.inner-container {
  max-width: 1270px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 2fr 1fr;
  padding-bottom: 100px;
}
.flex-right {
  display: flex;
  flex-direction: column;
}
.upper,
.lower {
  padding: 0 50px;
  padding-top: 20px;
  padding-bottom: 20px;
}
.flex-right h3 {
  font: 400 1rem/1.2rem 'Manrope';
  color: white;
}
.upper {
  background-color: #184dbd;
}
.lower h2 {
  font: 700 1.5rem/1.75rem 'Manrope';
  color: #29292b;
}
.lower h5 {
  font: 400 0.875rem/1rem 'Manrope';
  color: #29292b;
}

.lower {
  display: flex;
  flex-direction: column;
  background-color: white;
}
.lower img {
  align-self: flex-end;
}
.video {
  width: 849px;
  height: 478px;
}
@media only screen and (max-width: 600px) {
  .inner-container {
    max-width: 1270px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr;
    padding-bottom: 100px;
  }
  .video {
    width: 359px;
    height: 278px;
  }
  .upper img {
    padding-bottom: 25px;
  }
  .lower img {
    padding-top: 20px;
  }
}
</style>
